var TabEvent = Object.freeze({
  focus: 'TabEvent.focus',
  blur: 'TabEvent.blur'
});
export default TabEvent;
//# sourceMappingURL=TabEvent.js.map